<div class="d-flex justify-content-between">
  <div>
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div class="d-flex gap-4 align-items-top">
    <div class="backIconContiner" (click)="backToPreviousPage()" (keydown.enter)="backToPreviousPage()"
      matTooltip="Go back">
      <i class="fa fa-arrow-left"></i>
    </div>
  </div>
</div>


<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="form-template" *ngIf="groupInfo">
  <div class="row">
    <div class="col-md-2 field-styles">
      <!-- Group Code -->
      <div><label for="email">{{groupInfo['GROUP_CODE']}}</label><span class="mandatory-symbol">*</span></div>
      <input id="groupCodeValue" class="input-filed-continers" type="text" [(ngModel)]="qmsGroupsFieldData.groupCode"
        (focusout)="onQmsGroupFocusout()">
      <span id="groupCode-required-msg">Please enter the group code</span>
    </div>
    <div class="col-md-4 field-styles">
      <!-- Group Name -->
      <div><label for="email">{{groupInfo['GROUP_NAME']}}</label><span class="mandatory-symbol">*</span></div>
      <input id="groupNameValue" class="input-filed-continers" type="text" [(ngModel)]="qmsGroupsFieldData.groupName"
        (focusout)="onQmsGroupFocusout()">
      <span id="groupName-required-msg">Please enter the group name</span>
    </div>
    <div class="col-md-6 field-styles">
      <!-- Module -->
      <div><label for="email">{{groupInfo['MODULES']}}</label><span class="mandatory-symbol">*</span></div>
      <mat-select matInput multiple placeholder="Select" #modules [(ngModel)]="selectedQmsGroupsModuleValue"
        (closed)="modulesSearchText=''" (click)="focusSearch('focus-modules-search')"
        (keydown.enter)="focusSearch('focus-modules-search')">
        <input type="search" id="focus-modules-search" class="dropdownsearchstyle" [(ngModel)]="modulesSearchText"
          matInput placeholder="search">
        <div class="select-all">
          <mat-checkbox [(ngModel)]="isAllModulesSelected" (change)="toggleAllSelection('modules')">Select
            All</mat-checkbox>
        </div>
        <mat-option *ngFor="let item1 of qmsGroupsModuleValueDropdown | multiAssessmentSearchPipe :modulesSearchText"
          [value]="item1.valueExp" (onSelectionChange)="onModulesSelect($event,item1)">
          {{ item1.displayExp }}
        </mat-option>
      </mat-select>
      <span id="module-required-msg1">Please select the module</span>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2 field-styles">
      <!-- Quality Group Status -->
      <div><label for="email">{{groupInfo['IS_ACTIVE']}}</label></div>
      <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupsFieldData.isActive">
        <span class="active-inActive-container" *ngIf="qmsGroupsFieldData.isActive==true"
          [ngStyle]="qmsGroupsFieldData.isActive == true?{'color':'green'} : {'color': ''}">Active</span>
        <span *ngIf="qmsGroupsFieldData.isActive==false"
          [ngStyle]="qmsGroupsFieldData.isActive == false?{'color':'red'} : {'color': ''}">InActive</span>
      </mat-slide-toggle>
    </div>
    <div class="col-md-4 field-styles">
      <!-- Group Description -->
      <div><label for="email">{{groupInfo['GROUP_DESCRIPTION']}}</label></div>
      <textarea id="groupDescription" type="text" class="input-filed-textarea" rows="4" cols="50"
        [(ngModel)]="qmsGroupsFieldData.groupDescription"></textarea>
    </div>
    <div class="col-md-6 field-styles">
      <div><label for="email">{{groupInfo['UPDATE_REASON']}}</label><span class="mandatory-symbol">*</span></div>
      <textarea id="updateReason1" type="text" class="input-filed-textarea" rows="4" cols="50"
        [(ngModel)]="qmsGroupsFieldData.updateReason" (focusout)="onQmsGroupFocusout()"></textarea>
      <span id="updateReason-required-msg1">Please provide the reason for update</span>
    </div>
  </div>
  <br>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" style="margin-bottom: 1%"
      (click)="editQmsGroupsFunction(qmsGroupsFieldData)" (keydown.enter)="editQmsGroupsFunction(qmsGroupsFieldData)">
      <i class="fas fa-user-edit"></i> Update
    </button>
  </div>
</div>
<br>
<div class="position-relative grid-content">
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
        </div>
      </div>
      <div class="d-flex gap-3">
        <div class="header-container">
          <div class="">
            <div class="search-container">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
                [(ngModel)]="searchValue" />
            </div>
          </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.dataGridAdmin" matTooltip="Settings" (click)="openReorder()" (keydown.enter)="openReorder()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
            <path style="fill:'#FFFFFF'"
              d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
          </svg>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openQmsGroupDetailsAddPopup()" (keydown.enter)="openQmsGroupDetailsAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('DETAIL', 'Excel')" (keydown.enter)="openReport('DETAIL', 'Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('DETAIL','Pdf')" (keydown.enter)="openReport('DETAIL','Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="copyQmsGroupDetailsAddPopup()" (keydown.enter)="copyQmsGroupDetailsAddPopup()">
          <i class="fa-solid fa-copy" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Copy Quality Group Details</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('DETAIL','overAll',0)"
          (keydown.enter)="openAuditTrail('DETAIL','overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshQmsGroupDetailsGridData()" (keydown.enter)="refreshQmsGroupDetailsGridData()">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container">
    <table class="dynamic-table-container">
      <thead>
        <th style="min-width: 60px; text-align: center;"
          [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          <div style="display: flex;">
            <div>
              <i class="fa-solid fa-ellipsis-vertical parent-menu-icons"></i>
            </div>
          </div>
        </th>
        <th class="grid-header-container"
          *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;" [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width,'max-width': oneQmsUsersDataForTable1Data.width,'overflow': 'hidden',
      'text-overflow': 'ellipsis',
      'white-space': 'nowrap'}" class="sticky-dynamic-col1">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>{{ oneQmsUsersDataForTable1Data.fieldColumnarray }}</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)"
                (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div>
            </div>
          </div>
        </th>
        <th id="menu" class="sticky-col first-col"></th>
      </thead>
      <tbody>
        <tr>
          <td [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
          <td *ngFor="
                  let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray;
                  let ix = index
                " [ngStyle]="{
                  'min-width':
                    oneQmsUsersDataForTable1Data.width != null
                      ? oneQmsUsersDataForTable1Data.width
                      : '200px'
                }" class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="cssfunction(0)">
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" />
            </div>
          </td>
        </tr>
        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;"
          [class.highlightRow]="list.childCheckBoxs == true">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBoxs"
                  (change)="qmsGroupDetailsGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width !=null ? key.width :200,'max-width': key.width !=null ? key.width :200,'overflow': 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img alt="access" *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img alt="noaccess" *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg"
                  width="20" height="20">

              </div>
            </span>
            <span *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE'">{{ list[key.columnsListarray] }}</span>
            <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
          </td>
          <td class="sticky-col first-col">
            <div class="action-icons">
              <span *ngIf="list.MODULE!='CC'" class="qmsGroupDetailSettings-container"
                matTooltip="{{groupdetailSettingsTooltipTitle}}" style="margin-left: 5px;"
                (mouseover)="getRowData(list)" (click)="openQmsGroupDetailTypeSettingsPopup(list)"
                (keydown.enter)="openQmsGroupDetailTypeSettingsPopup(list)" (focus)="focusEmpty()"></span>
              <span class="qmsGroupUsers-container" matTooltip="Open Quality Group Users" style="margin-left: 5px;"
                (click)="onQmsGroupDetailsGridRowClicked(list)"
                (keydown.enter)="onQmsGroupDetailsGridRowClicked(list)"></span>
              <!-- <img alt="flexibility" src="../../../assets/img/flexibility.png" matTooltip="Flexifields"
                style="height: 18px;width: 18px;" (click)="openFlexifieldsPopup(list)"
                (keydown.enter)="openFlexifieldsPopup(list)" /> -->
              <i class="fa-solid fa-pencil" matTooltip="Edit Quality Group Details" style="margin-left: 5px;"
                (click)="openQmsGroupDetailsEditPopup(list)" (keydown.enter)="openQmsGroupDetailsEditPopup(list)"></i>
              <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete Quality Group Details" style="margin-left: 5px;"
                (click)="deleteCodelistPopop(list)" (keydown.enter)="deleteCodelistPopop(list)"></i>
              <span class="active-inActiveUsers" *ngIf="list.IS_ACTIVE == true "
                [ngStyle]="list.IS_ACTIVE == true ?{'color':'red'} : {'color': ''}"
                (click)="openActiveAndInActivePopup(list)" (keydown.enter)="openActiveAndInActivePopup(list)"
                matTooltip="Inactivate">
                <i class="fas fa-lock"></i>
              </span>
              <span class="active-inActiveUsers" *ngIf="list.IS_ACTIVE != true "
                [ngStyle]="list.IS_ACTIVE != true ?{'color':'green'} : {'color': ''}"
                (click)="openActiveAndInActivePopup(list)" (keydown.enter)="openActiveAndInActivePopup(list)"
                matTooltip="Activate">
                <i class="fas fa-lock-open"></i>
              </span>
              <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
                src="../../assets/img/trail-individual.svg" (click)="openAuditTrail('DETAIL','individual',list)"
                (keydown.enter)="openAuditTrail('DETAIL','individual',list)" />

            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" class="dropdownBasic1"
              ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #qmsGroupDetailsAddAndEditPopup>
    <div class="ng-template-container">
      <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
      </div>
      <button class="close close-button" (click)="cancelAddAndEditQmsGroupDetailsFunction()" mat-button><i
          class="fa popupClose">&#xf00d;</i></button>
      <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{popupTitle}}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
      </div>
      <div class="details-popup">
        <fieldset class="border p-2">
          <legend class="float-none w-auto p-2"><span class="legent-title">Group Details</span></legend>
          <div class="row">
            <div class="col-md-4">
              <!-- Module -->
              <div><label for="email">{{dynamicLabel['MODULE']}}</label><span class="mandatory-symbol">*</span></div>
              <mat-select matInput placeholder="Select" [(ngModel)]="selectedmoduleValue"
                [ngClass]="{'odd-item-mat-select': oddModuleValue== selectedmoduleValue}" (closed)="modulesearchTxt=''"
                (click)="focusmethod('groupModulefocusSearch')" (keydown.enter)="focusmethod('groupModulefocusSearch')">
                <input type="search" id="groupModulefocusSearch" class="dropdownsearchstyle"
                  [(ngModel)]="modulesearchTxt" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onModuleSelect($event,null);">Un-select</mat-option>
                <mat-option *ngFor="let item of grpupmoduleValueDropdown| assessmentSearch :modulesearchTxt"
                  (onSelectionChange)="onModuleSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
              <span id="module-required-msg2">Please select the module</span>
            </div>
            <div class="col-md-8">
              <!-- Skip Stages -->
              <div><label for="email">{{dynamicLabel['SKIP_STAGES']}}</label></div>
              <mat-select matInput multiple placeholder="Select" #skipStages [(ngModel)]="selectDocTypeName"
                (closed)="skipstagesearchTxt=''" (click)="focusSearch('skipstagefocusSearch')"
                (keydown.enter)="focusSearch('skipstagefocusSearch')">
                <input type="search" id="skipstagefocusSearch" class="dropdownsearchstyle"
                  [(ngModel)]="skipstagesearchTxt" matInput placeholder="Search">
                <div class="select-all">
                  <mat-checkbox [(ngModel)]="isSkipstageSelected" (change)="toggleAllSelection('skipStages')">Select
                    All</mat-checkbox>
                </div>
                <mat-option *ngFor="let item1 of skipstageValueDropdown | multiAssessmentSearchPipe :skipstagesearchTxt"
                  [value]="item1.valueExp" (onSelectionChange)="onDocTypeSelect($event, item1)">
                  {{ item1.displayExp }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="row field-styles">
            <div class="col-md-4">
              <!-- Final No Generation Stage -->
              <div><label for="email">{{dynamicLabel['FINAL_NO_GENERATION_STAGE']}}</label><span
                  class="mandatory-symbol">*</span></div>
              <mat-select matInput placeholder="Select" [(ngModel)]="selectfinalGenStage"
                [ngClass]="{'odd-item-mat-select': oddfinalGenStage== selectfinalGenStage}"
                (closed)="finalNoGenStagesearchTxt=''" (click)="focusmethod('finalNoGenStagefocusSearch')"
                (keydown.enter)="focusmethod('finalNoGenStagefocusSearch')">
                <input type="search" id="finalNoGenStagefocusSearch" class="dropdownsearchstyle"
                  [(ngModel)]="finalNoGenStagesearchTxt" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onFinalNoGenStageSelect($event,null);">Un-select</mat-option>
                <mat-option *ngFor="let item of finalstageValueDropdown| assessmentSearch :finalNoGenStagesearchTxt"
                  (onSelectionChange)="onFinalNoGenStageSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
              <span id="finalNoGenerationStage-required-msg">Please select the Final No. Generation Stage</span>
            </div>
            <div class="col-md-4"
              *ngIf="this.modulevalueexp!='IN' && this.modulevalueexp!='CC' && this.modulevalueexp!='AU'">
              <!-- Reopen Allowed -->
              <div><label for="email">{{dynamicLabel['REOPEN_ALLOWED']}}</label></div>
              <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupDetailsFieldData.reopenAllowed">
                <span class="active-inActive-container" *ngIf="qmsGroupDetailsFieldData.reopenAllowed==true"
                  [ngStyle]="qmsGroupDetailsFieldData.reopenAllowed == true?{'color':'green'} : {'color': ''}">Yes</span>
                <span *ngIf="qmsGroupDetailsFieldData.reopenAllowed==false"
                  [ngStyle]="qmsGroupDetailsFieldData.reopenAllowed == false?{'color':'red'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>
            <div class="col-md-4"
              *ngIf="this.modulevalueexp!='IN' && this.modulevalueexp!='CC' && this.modulevalueexp!='AU'">
              <!-- Reopen Actions Allowed(Revoke) -->
              <div>
                <label for="email">
                  {{dynamicLabel['REOPEN_ACTIONS_ALLOWED']}}
                  <span style="font-size: 10px; font-weight: bold;">(while revoking activity)</span>
                </label>
              </div>
              <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupDetailsFieldData.reopenActionsAllowed">
                <span class="active-inActive-container" *ngIf="qmsGroupDetailsFieldData.reopenActionsAllowed==true"
                  [ngStyle]="qmsGroupDetailsFieldData.reopenActionsAllowed == true?{'color':'green'} : {'color': ''}">Yes</span>
                <span *ngIf="qmsGroupDetailsFieldData.reopenActionsAllowed==false"
                  [ngStyle]="qmsGroupDetailsFieldData.reopenActionsAllowed == false?{'color':'red'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>
            <div class="col-md-4"
              *ngIf="this.modulevalueexp!='AU' && this.modulevalueexp!='IN' && this.modulevalueexp!='QI'&& this.modulevalueexp!='CC' && this.modulevalueexp!='CAPA' && this.modulevalueexp!='DV'">
              <!-- Effective Date Required -->
              <div><label for="email">Effective Date Required</label></div>
              <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupDetailsFieldData.isEffectiveDateReqd">
                <span class="active-inActive-container" *ngIf="qmsGroupDetailsFieldData.isEffectiveDateReqd==true"
                  [ngStyle]="qmsGroupDetailsFieldData.isEffectiveDateReqd == true?{'color':'green'} : {'color': ''}">Yes</span>
                <span *ngIf="qmsGroupDetailsFieldData.isEffectiveDateReqd==false"
                  [ngStyle]="qmsGroupDetailsFieldData.isEffectiveDateReqd == false?{'color':'red'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>
            <div class="col-md-4" *ngIf="modulevalueexp != 'AU' && modulevalueexp != 'OOS'">
              <div><label for="email">{{dynamicLabel['PRELIMINARY_ACTIONS_ENABLED']}}</label></div>
              <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupDetailsFieldData.preliminaryActionEnabled">
                <span class="active-inActive-container"
                  [ngStyle]="{ color: qmsGroupDetailsFieldData.preliminaryActionEnabled ? 'green' : 'red' }">
                  {{ qmsGroupDetailsFieldData.preliminaryActionEnabled ? 'Yes' : 'No' }}
                </span>
              </mat-slide-toggle>
            </div>
            <div class="col-md-4" *ngIf="this.modulevalueexp!='CC'">
              <!-- Effectiveness Check Required -->
              <div><label for="email">{{dynamicLabel['EFFECTIVENESS_CHECK_ENABLED']}}</label></div>
              <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupDetailsFieldData.effectivenessCheckEnabled">
                <span class="active-inActive-container" *ngIf="qmsGroupDetailsFieldData.effectivenessCheckEnabled==true"
                  [ngStyle]="qmsGroupDetailsFieldData.effectivenessCheckEnabled == true?{'color':'green'} : {'color': ''}">Yes</span>
                <span *ngIf="qmsGroupDetailsFieldData.effectivenessCheckEnabled==false"
                  [ngStyle]="qmsGroupDetailsFieldData.effectivenessCheckEnabled == false?{'color':'red'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>

            <div class="col-md-4"
              *ngIf="modulevalueexp != 'IN' && modulevalueexp != 'AU' && modulevalueexp != 'OOS' && (!selectDocTypeName.includes('QA Acceptance') || !selectDocTypeName.includes('QA Approval'))">
              <!-- Editable by Approvers -->
              <div><label for="email">{{dynamicLabel['EDITABLE_BY_QA']}}</label></div>
              <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupDetailsFieldData.editableByQA">
                <span class="active-inActive-container" *ngIf="qmsGroupDetailsFieldData.editableByQA==true"
                  [ngStyle]="qmsGroupDetailsFieldData.editableByQA == true?{'color':'green'} : {'color': ''}">Yes</span>
                <span *ngIf="qmsGroupDetailsFieldData.editableByQA==false"
                  [ngStyle]="qmsGroupDetailsFieldData.editableByQA == false?{'color':'red'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>
            <div class="col-md-4"
              *ngIf="(modulevalueexp == 'CAPA' || modulevalueexp == 'CR' || modulevalueexp == 'DV') && !selectDocTypeName.includes('Department Head Approval') ">
              <div><label for="email">{{dynamicLabel['EDITABLE_BY_DEPARTMENT_HEAD']}}</label></div>
              <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupDetailsFieldData.editableByDepartmentHead">
                <span class="active-inActive-container" *ngIf="qmsGroupDetailsFieldData.editableByDepartmentHead==true"
                  [ngStyle]="qmsGroupDetailsFieldData.editableByDepartmentHead == true?{'color':'green'} : {'color': ''}">Yes</span>
                <span *ngIf="qmsGroupDetailsFieldData.editableByDepartmentHead==false"
                  [ngStyle]="qmsGroupDetailsFieldData.editableByDepartmentHead == false?{'color':'red'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>
            <div class="col-md-4" *ngIf="(modulevalueexp == 'IN' || modulevalueexp == 'CC' || modulevalueexp == 'QI') ">
              <div><label for="email">{{dynamicLabel['EDITABLE_BY_INVESTIGATOR']}}</label></div>
              <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupDetailsFieldData.editableByInvestigator">
                <span class="active-inActive-container" *ngIf="qmsGroupDetailsFieldData.editableByInvestigator==true"
                  [ngStyle]="qmsGroupDetailsFieldData.editableByInvestigator == true?{'color':'green'} : {'color': ''}">Yes</span>
                <span *ngIf="qmsGroupDetailsFieldData.editableByInvestigator==false"
                  [ngStyle]="qmsGroupDetailsFieldData.editableByInvestigator == false?{'color':'red'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>
            <div class="col-md-4" *ngIf="this.modulevalueexp!='AU'">
              <!-- Editable by Approvers -->
              <div><label for="email">{{dynamicLabel['EDITABLE_BY_APPROVERS']}}</label></div>
              <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupDetailsFieldData.editableByApprovers">
                <span class="active-inActive-container" *ngIf="qmsGroupDetailsFieldData.editableByApprovers==true"
                  [ngStyle]="qmsGroupDetailsFieldData.editableByApprovers == true?{'color':'green'} : {'color': ''}">Yes</span>
                <span *ngIf="qmsGroupDetailsFieldData.editableByApprovers==false"
                  [ngStyle]="qmsGroupDetailsFieldData.editableByApprovers == false?{'color':'red'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>
            <div class="col-md-4" *ngIf="this.modulevalueexp!='AU'">
              <!-- Editable by Reviewers -->
              <div><label for="email">{{dynamicLabel['EDITABLE_BY_REVIEWERS']}}</label></div>
              <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupDetailsFieldData.editableByReviewers">
                <span class="active-inActive-container" *ngIf="qmsGroupDetailsFieldData.editableByReviewers==true"
                  [ngStyle]="qmsGroupDetailsFieldData.editableByReviewers == true?{'color':'green'} : {'color': ''}">Yes</span>
                <span *ngIf="qmsGroupDetailsFieldData.editableByReviewers==false"
                  [ngStyle]="qmsGroupDetailsFieldData.editableByReviewers == false?{'color':'red'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>
            <div class="col-md-4">
              <div>
                <label for="email">{{dynamicLabel['IS_EXTENSION_REQD']}}</label>
              </div>
              <mat-slide-toggle color="primary" name="extension-required"
                [(ngModel)]="qmsGroupDetailsFieldData.isExtensionRequired">
                <ng-container *ngIf="qmsGroupDetailsFieldData.isExtensionRequired; else no">
                  <span class="active-inActive-container" style="color: green;">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>
            <div class="col-md-4"
              *ngIf="selectedmoduleValue=='CR' || selectedmoduleValue=='CAPA' || selectedmoduleValue=='DV' ">
              <div>
                <label for="email">{{dynamicLabel['IS_GROUP_OWNER_REQD']}}</label>
              </div>
              <mat-slide-toggle color="primary" name="group-owner"
                [(ngModel)]="qmsGroupDetailsFieldData.isGroupOwnerRequired">
                <ng-container *ngIf="qmsGroupDetailsFieldData.isGroupOwnerRequired; else no">
                  <span class="active-inActive-container" style="color: green;">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>

            <div class="col-md-4">
              <div>
                <!-- Is Risk Calculation Required? -->
                <label for="email">{{dynamicLabel['IS_RISK_CALCULATION_REQD']}}</label>
              </div>
              <mat-slide-toggle color="primary" name="initiatedOnBehalfBy"
                [(ngModel)]="qmsGroupDetailsFieldData.isRiskCalculationReqd" (change)="onRiskCalculationChange()">
                <ng-container *ngIf="qmsGroupDetailsFieldData.isRiskCalculationReqd; else no">
                  <span class="active-inActive-container" style="color: green;">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>

            <div class="col-md-4" *ngIf="qmsGroupDetailsFieldData.isRiskCalculationReqd">
              <!-- Risk Formula -->
              <div><label for="email">{{dynamicLabel['RISK_FORMULA']}}</label></div>
              <textarea type="text" class="input-filed-textarea" style="width: 100%;" rows="4" cols="50"
                [(ngModel)]="qmsGroupDetailsFieldData.riskFormula"></textarea>
            </div>

            <div class="col-md-4" *ngIf="viewCheckList()">
              <div>
                <label for="email">{{dynamicLabel['ENABLE_CHECKLIST']}}</label>
              </div>
              <mat-slide-toggle color="primary" name="checklist" [(ngModel)]="qmsGroupDetailsFieldData.enableCheckList"
                (change)="onEnableCheckListChange()">
                <ng-container *ngIf="qmsGroupDetailsFieldData.enableCheckList; else no">
                  <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>
            <ng-container *ngIf="qmsGroupDetailsFieldData.enableCheckList">
              <div class="col-md-4">
                <div>
                  <label for="email">{{dynamicLabel['IS_CHECKLIST_SKIPPABLE']}}</label>
                </div>
                <mat-slide-toggle color="primary" name="skippable"
                  [(ngModel)]="qmsGroupDetailsFieldData.isCheckListSkippable">
                  <ng-container *ngIf="qmsGroupDetailsFieldData.isCheckListSkippable; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>

              <div class="col-md-4"
                *ngIf="selectedmoduleValue && (!(selectDocTypeName.includes('Review') || selectDocTypeName.includes('Peer Review')))">
                <div>
                  <label for="additionalNotificationStages">
                    {{dynamicLabel['REVIEW_CHECKLIST_TEMPLATE_NAME']}}
                    <span class="mandatory-symbol">*</span>
                  </label>
                </div>
                <mat-select #reviewTemplate matInput multiple placeholder="Select" [(ngModel)]="selectedReviewTemplate"
                  (click)="focusSearch('focus-review-template')" (keydown.enter)="focusSearch('focus-review-template')"
                  (closed)="reviewSearchText = ''">
                  <input type="search" id="focus-review-template" class="dropdownsearchstyle"
                    [(ngModel)]="reviewSearchText" matInput placeholder="Search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="isAllReviewTemplateSelected" (change)="toggleAllReviewTemplate()">
                      Select All
                    </mat-checkbox>
                  </div>
                  <mat-option *ngFor="let item of templateDropdown | multiAssessmentSearchPipe : reviewSearchText"
                    [value]="item.valueExp" (onSelectionChange)="onReviewTemplateSelect($event, item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-4" *ngIf="selectedmoduleValue != 'AU' && !selectDocTypeName.includes('Approve')">
                <div>
                  <label for="additionalNotificationStages">
                    {{dynamicLabel['APPROVE_CHECKLIST_TEMPLATE_NAME']}}
                    <span class="mandatory-symbol">*</span>
                  </label>
                </div>
                <mat-select #approveTemplate matInput multiple placeholder="Select"
                  [(ngModel)]="selectedApproveTemplate" (click)="focusSearch('focus-approve-template')"
                  (keydown.enter)="focusSearch('focus-approve-template')" (closed)="approveSearchText = ''">
                  <input type="search" id="focus-approve-template" class="dropdownsearchstyle"
                    [(ngModel)]="approveSearchText" matInput placeholder="Search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="isAllApproveTemplateSelected" (change)="toggleAllApproveTemplate()">
                      Select All
                    </mat-checkbox>
                  </div>
                  <mat-option *ngFor="let item of templateDropdown | multiAssessmentSearchPipe : approveSearchText"
                    [value]="item.valueExp" (onSelectionChange)="onApproveTemplateSelect($event, item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-4" *ngIf="selectedmoduleValue && !selectDocTypeName.includes('Closure Review')">
                <div>
                  <label for="additionalNotificationStages">
                    {{dynamicLabel['CLOSURE_REVIEW_CHECKLIST_TEMPLATE_NAME']}}
                    <span class="mandatory-symbol">*</span>
                  </label>
                </div>
                <mat-select #closureReviewTemplate matInput multiple placeholder="Select"
                  [(ngModel)]="selectedClosureReviewTemplate" (click)="focusSearch('focus-c-r-template')"
                  (keydown.enter)="focusSearch('focus-c-r-template')" (closed)="closureReviewSearchText = ''">
                  <input type="search" id="focus-c-r-template" class="dropdownsearchstyle"
                    [(ngModel)]="closureReviewSearchText" matInput placeholder="Search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="isAllClosureReviewTemplateSelected"
                      (change)="toggleAllClosureReviewTemplate()">
                      Select All
                    </mat-checkbox>
                  </div>
                  <mat-option
                    *ngFor="let item of templateDropdown | multiAssessmentSearchPipe : closureReviewSearchText"
                    [value]="item.valueExp" (onSelectionChange)="onClosureReviewTemplateSelect($event, item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-4" *ngIf="selectedmoduleValue && !selectDocTypeName.includes('Closure Approve')">
                <div>
                  <label for="additionalNotificationStages">
                    {{dynamicLabel['CLOSURE_APPROVE_CHECKLIST_TEMPLATE_NAME']}}
                    <span class="mandatory-symbol">*</span>
                  </label>
                </div>
                <mat-select #closureApproveTemplate matInput multiple placeholder="Select"
                  [(ngModel)]="selectedClosureApproveTemplate" (click)="focusSearch('focus-c-a-template')"
                  (keydown.enter)="focusSearch('focus-c-a-template')" (closed)="closureApproveSearchText = ''">
                  <input type="search" id="focus-c-a-template" class="dropdownsearchstyle"
                    [(ngModel)]="closureApproveSearchText" matInput placeholder="Search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="isAllClosureApproveTemplateSelected"
                      (change)="toggleAllClosureApproveTemplate()">
                      Select All
                    </mat-checkbox>
                  </div>
                  <mat-option
                    *ngFor="let item of templateDropdown | multiAssessmentSearchPipe : closureApproveSearchText"
                    [value]="item.valueExp" (onSelectionChange)="onClosureApproveTemplateSelect($event, item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
            </ng-container>

            <div class="col-md-4">
              <!-- Additional Notification Required -->
              <div><label for="email">{{dynamicLabel['ADDITIONAL_NOTIFICATION_REQD']}}</label></div>
              <mat-slide-toggle color="primary" [(ngModel)]="qmsGroupDetailsFieldData.additionalNotificationReqd"
                (change)="onAdditionalNotificationReqdChange()">
                <span class="active-inActive-container"
                  *ngIf="qmsGroupDetailsFieldData.additionalNotificationReqd==true"
                  [ngStyle]="qmsGroupDetailsFieldData.additionalNotificationReqd == true?{'color':'green'} : {'color': ''}">Yes</span>
                <span *ngIf="qmsGroupDetailsFieldData.additionalNotificationReqd==false"
                  [ngStyle]="qmsGroupDetailsFieldData.additionalNotificationReqd == false?{'color':'red'} : {'color': ''}">No</span>
              </mat-slide-toggle>
            </div>
            <div class="col-md-6" *ngIf="qmsGroupDetailsFieldData.additionalNotificationReqd">
              <div>
                <label for="additionalNotificationStages">Additional Notification Stages
                  <span class="mandatory-symbol">*</span>
                </label>
              </div>
              <textarea *ngIf="activityStatusDropdown.length === 0" class="input-filed-textarea"
                [(ngModel)]="qmsGroupDetailsFieldData.additionalNotificationStages" rows="4" cols="50"> </textarea>
              <mat-select matInput *ngIf="activityStatusDropdown.length > 0" multiple placeholder="Select" #status
                [(ngModel)]="selectedNotificationStatuses" (closed)="qualityRolesSearchText=''"
                (click)="focusSearch('focus-status')" (keydown.enter)="focusSearch('focus-status')">
                <input type="search" id="focus-status" class="dropdownsearchstyle" [(ngModel)]="statusSearchText"
                  matInput placeholder="Search">
                <div class="select-all">
                  <mat-checkbox [(ngModel)]="isAllNotificationSelected" (change)="toggleAllSelection('status')">Select
                    All</mat-checkbox>
                </div>
                <mat-option *ngFor="let item1 of activityStatusDropdown | multiAssessmentSearchPipe :statusSearchText"
                  [value]="item1.valueExp" (onSelectionChange)="onStatusSelectAll($event, item1)">
                  {{ item1.displayExp }}
                </mat-option>
              </mat-select>
              <span id="status-required-msg">Please select the status</span>
            </div>
            <div class="row col-md-6" *ngIf=" qmsGroupDetailsFieldData.additionalNotificationReqd">
              <!-- Additional Notification User(s) -->
              <div><label for="email">Additional Notification User(s)</label></div>
              <div id="toUserNames" class="col-md-5 users-container">
                <div class="file-list">
                  <span class="user-name" *ngFor="let user of selectedUsersArray; let i = index">
                    {{user.userName}}&nbsp;&nbsp;
                    <button class="remove-file-button" (click)="onUserRemoved(i)"
                      matTooltip="Remove User">✕</button></span>
                </div>
              </div>
              <div class="col-md-1 search-icon-div">
                <div class="search-user" style="font-size: 1.3em" matTooltip="Search User(s)"
                  (click)="opensSearchUsersPopup()" (keydown.enter)="opensSearchUsersPopup()">
                  <i class="fa fa-search"></i>
                </div>
                <div *ngIf="selectedUsersArray.length > 1" matTooltip="Remove All User(s)" class="search-user"
                  style="font-size: 1.3em" (click)="removeAllUsers()" (keydown.enter)="removeAllUsers()">
                  <i class="fa fa-trash"></i>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <!-- masterpage Dashboard -->
              <div><label for="email">{{dynamicLabel['MASTERPAGE_DASHBOARD']}}</label></div>
              <mat-select matInput placeholder="Select" [(ngModel)]="selectedmasterpageDashboard"
                [ngClass]="{'odd-item-mat-select': oddmasterpageDashboardValue== selectedmasterpageDashboard}"
                (closed)="masterpageDashboardsearchTxt=''" (click)="focusmethod('masterpageDashboardfocusSearch')"
                (keydown.enter)="focusmethod('masterpageDashboardfocusSearch')">
                <input type="search" id="masterpageDashboardfocusSearch" class="dropdownsearchstyle"
                  [(ngModel)]="masterpageDashboardsearchTxt" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null"
                  (onSelectionChange)="onMasterpageDashboardSelect($event,null);">Un-select</mat-option>
                <mat-option
                  *ngFor="let item of masterPageDashboardDropdown| assessmentSearch :masterpageDashboardsearchTxt"
                  (onSelectionChange)="onMasterpageDashboardSelect($event,item)" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
              <span id="module-required-msg2">Please select the module</span>
            </div>

            <div class="col-md-3" *ngIf="modulevalueexp === 'CC'">
              <div>
                <label for="activityHandler">{{ dynamicLabel['ACTIVITY_HANDLER'] }}</label>
                <span class="mandatory-symbol">*</span>
              </div>
              <mat-select placeholder="Select" [(ngModel)]="activityHandler" (closed)="activityHandlerSearchText = ''"
                (click)="focusSearch('focus-activity-handler-search')"
                (keydown.enter)="focusSearch('focus-activity-handler-search')">
                <mat-option class="unselectStyle" [value]="null">
                  Un-select
                </mat-option>
                <mat-option *ngFor="let item of activityHandlerOptions | assessmentSearch: activityHandlerSearchText"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
              <span id="activity-handler-required-msg">Please select activity handler</span>
            </div>

            <div class="col-md-4" *ngIf="this.modulevalueexp=='OOS'">
              <!--activity closure days -->
              <div>
                <label for="email">{{dynamicLabel['ACTIVITY_CLOSURE_DAYS']}}</label>
              </div>
              <input id="value" type="number" class="input-filed-continers" (keypress)="validateNumberFields($event)"
                [(ngModel)]="qmsGroupDetailsFieldData.activityClosureDays" placeholder="Enter number of days" />
            </div>

          </div>
        </fieldset>

        <div class="row">

        </div>
        <div class="row">
        </div>
        <div class="row">
        </div>

        <div class="row" *ngIf="this.modulevalueexp!='AU' && this.modulevalueexp!='IN'">
        </div>

        <div class="row" *ngIf="this.modulevalueexp=='AU'">
        </div>

        <div class="row" *ngIf="this.modulevalueexp=='AU'">
        </div>

        <div class="row" *ngIf="isForAuditCategory || this.modulevalueexp=='AU'">
          <div class="col-md-12">
            <fieldset class="border p-2">
              <legend class="float-none w-auto p-2"><span class="legent-title">Audit Reference Groups</span>
              </legend>
              <div class="row">
                <div class="col-md-6">
                  <!-- SubGroup List -->
                  <div><label for="email">SubGroup List<span class="inDaysStyle">(By comma seperated)</span></label>
                  </div>
                  <input class="input-filed-continers" type="text"
                    [(ngModel)]="qmsGroupDetailsFieldData.auditSubGroupList">

                </div>
                <div class="col-md-6">
                  <!-- Annual Reference List -->
                  <div><label for="email">Annual Reference List<span class="inDaysStyle">(By comma
                        seperated)</span></label></div>
                  <input class="input-filed-continers" type="text"
                    [(ngModel)]="qmsGroupDetailsFieldData.auditAnnualRefList">
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <div class="row field-styles" id="scrollToUpdateReason" *ngIf="visibleEditButton"
          (click)="scrollToUpdateReason()" (keydown.enter)="scrollToUpdateReason()">
          <div class="col-md-6">
            <!-- Reason for Update -->
            <div><label for="email">Reason for Update</label><span class="mandatory-symbol">*</span></div>
            <textarea id="updateReason2" type="text" class="input-filed-textarea" style="width: 100%;" rows="4"
              cols="50" [(ngModel)]="qmsGroupDetailsFieldData.updateReason"
              (focusout)="onQmsGroupDetailsFocusout()"></textarea>
            <span id="updateReason-required-msg2">Please provide the reason for update</span>
          </div>
        </div>

      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="addAndEditQmsGroupDetailsFunction(qmsGroupDetailsFieldData)"
        (keydown.enter)="addAndEditQmsGroupDetailsFunction(qmsGroupDetailsFieldData)" *ngIf="visibleAddButton">
        <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
        <span class="reload_text text-white">Add New</span>
      </div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="addAndEditQmsGroupDetailsFunction(qmsGroupDetailsFieldData)"
        (keydown.enter)="addAndEditQmsGroupDetailsFunction(qmsGroupDetailsFieldData)"
        *ngIf="visibleEditButton && qmsGroupDetailsFieldData.isActive==true">
        <span class="reload_text text-white"> <i class="fas fa-user-edit"></i> Update</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditQmsGroupDetailsFunction()"
        (keydown.enter)="cancelAddAndEditQmsGroupDetailsFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>

  <ng-template #qmsGroupDetailsCopyPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelCopyFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{popupTitle}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Group</label><span class="mandatory-symbol">*</span></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedCopyGroupValue"
            (closed)="copyGroupsearchTxt=''" (click)="focusmethod('copyGroupfocusSearch')"
            (keydown.enter)="focusmethod('copyGroupfocusSearch')">
            <input type="search" id="copyGroupfocusSearch" class="dropdownsearchstyle" [(ngModel)]="copyGroupsearchTxt"
              matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onCopyGroupSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of copyGroupValueDropdown| assessmentSearch :copyGroupsearchTxt"
              (onSelectionChange)="onCopyGroupSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-12" style="margin-top: 9%;">
          <div><label for="email">Group Detail</label><span class="mandatory-symbol">*</span></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedCopyGroupDetailValue"
            (closed)="copyGroupDetailssearchTxt=''" (click)="focusmethod('copyGroupDetailsfocusSearch')"
            (keydown.enter)="focusmethod('copyGroupDetailsfocusSearch')">
            <input type="search" id="copyGroupDetailsfocusSearch" class="dropdownsearchstyle"
              [(ngModel)]="copyGroupDetailssearchTxt" matInput placeholder="Search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onCopyGroupDetailsSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of copyGroupDetailValueDropdown| assessmentSearch :copyGroupDetailssearchTxt"
              (onSelectionChange)="onCopyGroupDetailsSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions style="margin-top: 9%;">
        <button mat-stroked-button class="deleteButton" (click)="copyFunction()">
          <i class="fas fa-copy"></i> Copy
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelCopyFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #activeAndInActivePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelActiveAndInActiveFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{popupTitle}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Reason for Delete</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea1" type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="qmsGroupDetailsFieldData.deleteReason" (focusout)="onActiveAndInActiveFocusout()"></textarea>
          <span id="deleteTextarea-required-msg1">Please provide the reason for delete</span>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <button mat-stroked-button class="deleteButton" (click)="activeAndInActiveFunction()">
          <i class="fas fa-trash"></i> Delete
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelActiveAndInActiveFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </ng-template>


</div>


<ng-template #qmsGroupUsersPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelFunctionForQmsGroupUsersPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{groupUserTitle}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="static-table-popup">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
        </div>
      </div>
      <div class="d-flex gap-3">
        <div class="header-container">

        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openQmsGroupUsersAddPopup()" (keydown.enter)="openQmsGroupUsersAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('USER', 'Excel')" (keydown.enter)="openReport('USER', 'Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('USER','Pdf')" (keydown.enter)="openReport('USER','Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('USER','overAll',0)"
          (keydown.enter)="openAuditTrail('USER','overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshQmsGroupUsersGridData()" (keydown.enter)="refreshQmsGroupUsersGridData()">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
    <div class="table-container">
      <table class="groupUsers-table-tag-container" style="max-height: 55vh;">
        <thead>
          <th class="sticky-checkbox-columns checkbox-columns">
            <div style="display: flex;">
              <div>
                <i class="fa-solid fa-ellipsis-vertical parent-menu-icons"></i>
              </div>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>User Name</span>
              <div class="d-flex gap-2 align-items-center">
                <div (click)="sortColumn('Created On',0)" (keydown.enter)="sortColumn('Created On',0)">
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="columnSearch('userName', $event,'string')" />
            </div>
          </th>


          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>Quality Roles</span>
              <div class="d-flex gap-2 align-items-center">
                <div (click)="sortColumn('Quality Roles',0)" (keydown.enter)="sortColumn('Quality Roles',0)">
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="columnSearch('qmsRoles', $event,'string')" />
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>Is Active?</span>
              <div class="d-flex gap-2 align-items-center">
                <div (click)="sortColumn('Is Active',0)" (keydown.enter)="sortColumn('Is Active',0)">
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="columnSearch('isActive', $event,'string')" />
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>Assigned On</span>
              <div class="d-flex gap-2 align-items-center">
                <div (click)="sortColumn('Is Active',0)" (keydown.enter)="sortColumn('Is Active',0)">
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="columnSearch('assignedOn', $event,'date')" />
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>Assigned By</span>
              <div class="d-flex gap-2 align-items-center">
                <div (click)="sortColumn('Is Active',0)" (keydown.enter)="sortColumn('Is Active',0)">
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="columnSearch('assignedByUser', $event,'date')" />
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>Updated By</span>
              <div class="d-flex gap-2 align-items-center">
                <div (click)="sortColumn('Is Active',0)" (keydown.enter)="sortColumn('Is Active',0)">
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="columnSearch('updatedBy', $event,'string')" />
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>Updated On</span>
              <div class="d-flex gap-2 align-items-center">
                <div (click)="sortColumn('Is Active',0)" (keydown.enter)="sortColumn('Is Active',0)">
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="columnSearch('updatedOn', $event,'date')" />
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
              <span>Updated Reason</span>
              <div class="d-flex gap-2 align-items-center">
                <div (click)="sortColumn('Update Reason',0)" (keydown.enter)="sortColumn('Update Reason',0)">
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="columnSearch('updatedOn', $event,'date')" />
            </div>
          </th>

          <th id="menus" class="sticky-col first-col"></th>
        </thead>
        <tr class="data-row-container" *ngIf="qmsGroupsUsersList.length==0">
          <td colspan="7" class="grid-message-container"> No data to display </td>
        </tr>
        <tbody>
          <tr class="data-row-container" *ngFor="let groupUsers of groupUsersPagedItems; let idx = index;"
            [class.highlightRow]="groupUsers.childCheckBoxs == true">
            <td class="sticky-checkbox-columns checkbox-columns">
              <div style="display: flex;">
                <div [ngClass]="groupUsers.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input id="selectedManagerCheckBox" type="checkbox" style="zoom: 1.2;"
                    [checked]="groupUsers.childCheckBoxs"
                    (change)="qmsGroupUsersGridChildCheckBoxChecked($event, groupUsers, idx)">
                </div>
              </div>
            </td>
            <td style="min-width: 200px;max-width: 200px;" class="row-data sticky-dynamic-column">
              {{groupUsers.userName}}
            </td>
            <td style="min-width: 600px;max-width: 600px;" class="row-data sticky-dynamic-column">
              {{groupUsers.qmsRoles}}
            </td>
            <td style="min-width: 160px;max-width: 160px;" class="row-data sticky-dynamic-column"
              style="text-align: center;">
              <ng-container *ngIf="groupUsers.isActive === 'Y'; else noAccess">
                <img src="../../assets/img/accessSymbol.svg" alt="Yes" width="20" height="20">
              </ng-container>
              <ng-template #noAccess>
                <img src="../../assets/img/noAcessSymbol.svg" alt="No" width="20" height="20">
              </ng-template>
            </td>

            <td style="min-width: 200px;max-width: 200px;" class="row-data sticky-dynamic-column">
              {{groupUsers.assignedOn|date: 'dd-MMM-yyyy HH:mm:ss'}}
            </td>
            <td style="min-width: 200px;max-width: 200px;" class="row-data sticky-dynamic-column">
              {{groupUsers.assignedByUser}}
            </td>
            <td style="min-width: 200px;max-width: 200px;" class="row-data sticky-dynamic-column">
              {{groupUsers.updatedByUser}}
            </td>
            <td style="min-width: 200px;max-width: 200px;" class="row-data sticky-dynamic-column">
              {{groupUsers.updatedOn | date: 'dd-MMM-yyyy HH:mm:ss'}}
            </td>
            <td style="min-width: 200px;max-width: 200px;" class="row-data sticky-dynamic-column">
              {{groupUsers.updateReason}}
            </td>
            <td class="sticky-col first-col">
              <div class="action-icons">
                <i class="fa-solid fa-pencil" matTooltip="Edit Quality Group User" style="margin-left: 5px;"
                  (click)="openQmsGroupUsersEditPopup(groupUsers)"
                  (keydown.enter)="openQmsGroupUsersEditPopup(groupUsers)"></i>
                <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete Quality Group User" style="margin-left: 5px;"
                  (click)="openQmsGroupUsersDeletePopup(groupUsers)"
                  (keydown.enter)="openQmsGroupUsersDeletePopup(groupUsers)"></i>
                <span class="active-inActiveUsers" *ngIf="groupUsers.isActive=='Y'; else inactive" style="color: red;"
                  (click)="openActiveAndInActivePopupForUser(groupUsers)"
                  (keydown.enter)="openActiveAndInActivePopupForUser(groupUsers)" matTooltip="Inactivate"> <i
                    class="fas fa-lock"></i>
                </span>
                <ng-template #inactive>
                  <span class="active-inActiveUsers" *ngIf="groupUsers.isActive=='N'" style="color: green;"
                    (click)="openActiveAndInActivePopupForUser(groupUsers)"
                    (keydown.enter)="openActiveAndInActivePopupForUser(groupUsers)" matTooltip="Activate"> <i
                      class="fas fa-lock-open"></i>
                  </span>
                </ng-template>
                <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
                  src="../../assets/img/trail-individual.svg" (click)="openAuditTrail('USER','individual',groupUsers)"
                  (keydown.enter)="openAuditTrail('USER','individual',groupUsers)" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-center" *ngIf="qmsGroupsUsersList.length">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ groupUsersPerPage }} of {{ groupUsersCollectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="groupUsersSetPage(groupUsersPager.currentPage, $event)"
              [disabled]="false" [collectionSize]="groupUsersPager.totalItems" [(page)]="groupUsersPager.currentPage"
              [maxSize]="groupUsersMaxSize" [rotate]="true" [pageSize]="groupUsersPerPage" [ellipses]="false"
              [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" class="dropdownBasic1"
              ngbDropdownToggle>
              {{ groupUsersPerPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="groupUsersPaginationCall(10)">10</button>
              <button ngbDropdownItem (click)="groupUsersPaginationCall(20)">20</button>
              <button ngbDropdownItem (click)="groupUsersPaginationCall(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #qmsGroupUsersAddAndEditPopup>
  <div class="ng-template-container" style="height: 250px;">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunctionForQmsGroupUsers()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="add-user-container">
      <div class="row">
        <div class="col-md-4">
          <div><label for="user">User Name</label><span class="mandatory-symbol">*</span></div>
          <mat-select placeholder="Select" [(ngModel)]="selectedQmsUser" [multiple]="operationFlag == 'ADD'"
            [disabled]="operationFlag == 'EDIT'" (click)="focusmethod('userSearchInput')"
            (keydown.enter)="focusmethod('userSearchInput')">

            <mat-select-trigger>
              {{ getSelectedQmsUsersLabel() }}
            </mat-select-trigger>

            <input type="search" id="userSearchInput" class="dropdownsearchstyle" [(ngModel)]="qmsUserSearchTxt"
              (input)="filterQmsUsersList()" placeholder="Search users...">

            <div class="select-all" *ngIf="operationFlag == 'ADD' && (!qmsUserSearchTxt ||
              qmsUserSearchTxt.trim().length===0)">
              <mat-checkbox [(ngModel)]="isQmsUserSelectedAll" (change)="toggleAllQmsUsers()">Select All (Max
                50)</mat-checkbox>
            </div>

            <mat-option *ngFor="let user of filteredQmsUsersList" [value]="user.valueExp">
              {{ user.displayExp }}
            </mat-option>
          </mat-select>
          <span id="users-required-msg" style="color:red; display:none;">Please select a user</span>
        </div>
        <div class="col-md-4">
          <div><label for="email">Quality Roles</label><span class="mandatory-symbol">*</span></div>
          <mat-select matInput multiple placeholder="Select" #qualityRoles [(ngModel)]="selectedQmsRole"
            (closed)="qualityRolesSearchText=''" (click)="focusSearch('qualityRolesfocus')"
            (keydown.enter)="focusSearch('qualityRolesfocus')">
            <input type="search" id="qualityRolesfocus" class="dropdownsearchstyle" [(ngModel)]="qualityRolesSearchText"
              matInput placeholder="Search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="isQmsRoleSelected" (change)="toggleAllSelection('qualityRoles')">Select
                All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of qmsRolesListDropdown | multiAssessmentSearchPipe :qualityRolesSearchText"
              [value]="item1.valueExp" (onSelectionChange)="onQualityRolesSelectAll($event, item1)">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
          <span id="qmsRoles-required-msg">Please select the QMS Roles</span>
        </div>
        <div class="col-md-4" *ngIf="visibleEditButton">
          <div><label for="email" id="update-validation">Update Reason</label> <span class="mandatory-symbol">*</span>
          </div>
          <textarea id="update-text" class="input-filed-textarea" rows="1" cols="50"
            [(ngModel)]="qmsGroupUsersFieldData.updateReason"></textarea>
          <span id="update-required-msg" style="color:red; display:none;">Please enter the update reason</span>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer mt-2" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunctionForQmsGroupUsers(qmsGroupUsersFieldData)"
      *ngIf="visibleAddButton">
      <i class="fas fa-plus"></i> Add
    </button>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunctionForQmsGroupUsers(qmsGroupUsersFieldData)"
      *ngIf="visibleEditButton">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunctionForQmsGroupUsers()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #qmsGroupUsersDeletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{popupTitle}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Reason for Delete</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea2" type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="qmsGroupUsersFieldData.deleteReason" (focusout)="onQmsGroupUsersFocusout()"></textarea>
          <span id="deleteTextarea-required-msg2">Please provide the reason for delete</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction(qmsGroupUsersFieldData)">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #qmsGroupActiveInactivePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelQmsGroupActiveInActiveFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{popupTitle}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="row">
      <div class="col-md-12">
        <div><label for="email">{{activeInactiveLabel}}</label><span class="mandatory-symbol">*</span></div>
        <textarea id="groupActiveInactiveReason" type="text" class="input-filed-textarea" style="width: 100%;" rows="4"
          cols="50" [(ngModel)]="qmsGroupUsersFieldData.groupActiveInactiveReason"
          (focusout)="onQmsGroupActiveAndInActiveFocusout()"></textarea>
        <span id="groupActiveInactiveReason-required-msg">Please provide the reason for {{errorMsgContent}} </span>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="qmsGroupActiveInActiveFunction()">
        <i class="fas fa-lock" *ngIf="!groupActionFlag"></i><i class="fas fa-lock-open" *ngIf="groupActionFlag"></i>
        {{activeInactiveButtonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelQmsGroupActiveInActiveFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #qmsGroupUserActiveInactivePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelQmsGroupUserActiveInActiveFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{popupTitle}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="row">
      <div class="col-md-12">
        <div><label for="email">{{activeInactiveLabel}}</label><span class="mandatory-symbol">*</span></div>
        <textarea id="groupUserActiveInactiveReason" type="text" class="input-filed-textarea" style="width: 100%;"
          rows="4" cols="50" [(ngModel)]="qmsGroupUsersFieldData.groupActiveInactiveReason"
          (focusout)="onQmsGroupUserActiveAndInActiveFocusout()"></textarea>
        <span id="groupUserActiveInactiveReason-required-msg">Please provide the reason for {{errorMsgContent}}
        </span>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="qmsGroupUserActiveInActiveFunction(qmsGroupUsersFieldData)">
        <i class="fas fa-lock" *ngIf="!groupActionFlag"></i><i class="fas fa-lock-open" *ngIf="groupActionFlag"></i>
        {{activeInactiveButtonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelQmsGroupUserActiveInActiveFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #qmsGroupDetailTypeSettingsPopup>
  <button class="close close-button" (click)="cancelQmsGroupDetailTypeSettingsPopupFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ titleOfQmsGroupDetailSetting }} Type Settings</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>

  <div class="qmsGroupDetailTypeSettings-msg-container" *ngIf="this.codelistCodeData.length==0">
    <span>No data available in CodeLists</span>
  </div>
  <div class="static-table-popup">
    <div *ngIf="this.codelistCodeData.length>0">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center px-3">
          <div class="dropdown">
          </div>
        </div>
        <div class="d-flex gap-3">
          <div class="header-container">
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openQMSGroupDetailTypeSettingsAddPopup()"
            (keydown.enter)="openQMSGroupDetailTypeSettingsAddPopup()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add New</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReport('TYPE', 'Excel')" (keydown.enter)="openReport('TYPE', 'Excel')">
            <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Excel Report</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReport('TYPE','Pdf')" (keydown.enter)="openReport('TYPE','Pdf')">
            <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">PDF Report</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('TYPE','overAll',0)"
            (keydown.enter)="openAuditTrail('TYPE','overAll',0)">
            <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Audit Traill</span>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="refreshQMSGroupDetailTypeSettingsGridData()"
            (keydown.enter)="refreshQMSGroupDetailTypeSettingsGridData()">
            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
            <span class="reload_text">Reload</span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="this.codelistCodeData.length>0">
      <table class="qmsGroupDetailTypeSettings-table-container" style="max-height: 70vh;">
        <thead>
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i class="fa-solid fa-ellipsis-vertical parent-menu-icons"></i>
              </div>
              <div style="margin-left: 5px;">
              </div>
            </div>
          </th>
          <th>
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2"> <span>Type</span>
              <div class="d-flex gap-2 align-items-center">
                <div>
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
          </th>
          <th>
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2"> <span>To Be Started
                In
                Days</span>
              <div class="d-flex gap-2 align-items-center">
                <div>
                  <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                </div>
              </div>
            </div>
          </th>
          <th>
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2"> <span>To Be Closed
                In
                Days</span>
              <div class="d-flex gap-2 align-items-center">
                <div> <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" /> </div>
              </div>
            </div>
          </th>
          <th>
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2"> <span>Recalculate
                Closure Date When Activity Starts</span>
              <div class="d-flex gap-2 align-items-center">
                <div> <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" /> </div>
              </div>
            </div>
          </th>
          <th>
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2"> <span>Update
                Reason</span>
              <div class="d-flex gap-2 align-items-center">
                <div> <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" /> </div>
              </div>
            </div>
          </th>
          <th>
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2"> <span>Created
                On</span>
              <div class="d-flex gap-2 align-items-center">
                <div> <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" /> </div>
              </div>
            </div>
          </th>
          <th>
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2"> <span>Created
                By</span>
              <div class="d-flex gap-2 align-items-center">
                <div> <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" /> </div>
              </div>
            </div>
          </th>
          <th>
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2"> <span>Updated
                On</span>
              <div class="d-flex gap-2 align-items-center">
                <div> <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" /> </div>
              </div>
            </div>
          </th>
          <th>
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2"> <span>Updated
                By</span>
              <div class="d-flex gap-2 align-items-center">
                <div> <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" /> </div>
              </div>
            </div>
          </th>
          <th id="menuss" class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container"
            *ngFor="let listOfQmsGroupDetailTypeSettingsVwDetails of getQmsGroupDetailTypeSettingsVwDetails; let idx = index;"
            [class.highlightRow]="listOfQmsGroupDetailTypeSettingsVwDetails.qmsGroupDetailTypeSettingsVwChildCheckBoxs == true">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div
                  [ngClass]="listOfQmsGroupDetailTypeSettingsVwDetails.searchManagerChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input id="" type="checkbox" style="zoom: 1.2;"
                    [checked]="listOfQmsGroupDetailTypeSettingsVwDetails.qmsGroupDetailTypeSettingsVwChildCheckBoxs"
                    (change)="qmsGroupDetailTypeSettingsVwChildCheckBoxChecked($event, listOfQmsGroupDetailTypeSettingsVwDetails, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ listOfQmsGroupDetailTypeSettingsVwDetails.type }}</td>
            <td class="row-data">{{ listOfQmsGroupDetailTypeSettingsVwDetails.toBeStartedInDays }}</td>
            <td class="row-data">{{ listOfQmsGroupDetailTypeSettingsVwDetails.toBeClosedInDays }}</td>
            <td class="row-data sticky-dynamic-column" style="text-align: center;">
              <ng-container
                *ngIf="listOfQmsGroupDetailTypeSettingsVwDetails.recalculateClosureDateWhenActivityStarts === 'Y'; else noAccess">
                <img src="../../assets/img/accessSymbol.svg" width="20" height="20" alt="Yes">
              </ng-container>
              <ng-template #noAccess>
                <img src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="No">
              </ng-template>
            </td>
            <td class="row-data">{{ listOfQmsGroupDetailTypeSettingsVwDetails.updateReason }}</td>
            <td class="row-data">{{ listOfQmsGroupDetailTypeSettingsVwDetails.createdOn | date: 'dd-MMM-yyyy HH:mm:ss'
              }}
            </td>
            <td class="row-data">{{ listOfQmsGroupDetailTypeSettingsVwDetails.createdByUser }}</td>
            <td class="row-data">{{ listOfQmsGroupDetailTypeSettingsVwDetails.updatedOn | date: 'dd-MMM-yyyy HH:mm:ss'
              }}
            </td>
            <td class="row-data">{{ listOfQmsGroupDetailTypeSettingsVwDetails.updatedByUser }}</td>
            <td class="sticky-col first-col">
              <div class="action-icons">
                <i class="fa-solid fa-pencil" matTooltip="Edit {{titleOfQmsGroupDetailSetting}} Type Settings"
                  style="margin-left: 5px;"
                  (click)="openQMSGroupDetailTypeSettingsEditPopup(listOfQmsGroupDetailTypeSettingsVwDetails)"
                  (keydown.enter)="openQMSGroupDetailTypeSettingsEditPopup(listOfQmsGroupDetailTypeSettingsVwDetails)"></i>
                <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete {{titleOfQmsGroupDetailSetting}} Type Settings"
                  style="margin-left: 5px;"
                  (click)="openQMSGroupDetailTypeSettingsDeletePopup(listOfQmsGroupDetailTypeSettingsVwDetails)"
                  (keydown.enter)="openQMSGroupDetailTypeSettingsDeletePopup(listOfQmsGroupDetailTypeSettingsVwDetails)"></i>
                <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
                  src="../../assets/img/trail-individual.svg"
                  (click)="openAuditTrail('TYPE','individual',listOfQmsGroupDetailTypeSettingsVwDetails)"
                  (keydown.enter)="openAuditTrail('TYPE','individual',listOfQmsGroupDetailTypeSettingsVwDetails)" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #qmsGroupDetailTypeSettingsAddAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunctionForQmsGroupDetailTypeSettings()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <div class="col-md-4">
          <div><label for="email">{{ this.titleOfQmsGroupDetailSetting }} Type</label><span
              class="mandatory-symbol">*</span></div>
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedTypeValue"
            [ngClass]="{'odd-item-mat-select': oddTypeValue== selectedTypeValue}" (closed)="typesearchTxt=''"
            (click)="focusmethod('typefocusSearch')" (keydown.enter)="focusmethod('typefocusSearch')">
            <input type="search" id="typefocusSearch" class="dropdownsearchstyle" [(ngModel)]="typesearchTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" [value]="null"
              (onSelectionChange)="onTypeValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of typeDropdownData| assessmentSearch :typesearchTxt"
              (onSelectionChange)="onTypeValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <span id="type-required-msg">Please select the {{ this.titleOfQmsGroupDetailSetting }} Type</span>
        </div>
        <div class="col-md-3">
          <div><label for="email">
              <span
                [hidden]="this.titleOfQmsGroupDetailSetting=='AU' && (this.typeValue=='Findings-Critical'||this.typeValue=='Findings-Major'||this.typeValue=='Findings-Minor')">To
                Be Started <span class="inDaysStyle">(In Days)</span></span>
              <span
                *ngIf="this.titleOfQmsGroupDetailSetting=='AU' && (this.typeValue=='Findings-Critical'||this.typeValue=='Findings-Major'||this.typeValue=='Findings-Minor')">Expected
                Response In Date</span></label></div>
          <input class="input-filed-continers" type="number" min="1"
            [(ngModel)]="qmsGroupDetailTypeSettingsFieldData.toBeStartedInDays"
            (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-3">
          <div><label for="email"> To Be Closed <span class="inDaysStyle">(In Days)</span></label></div>
          <input class="input-filed-continers" type="number" min="1"
            [(ngModel)]="qmsGroupDetailTypeSettingsFieldData.toBeClosedInDays" (keydown)="validateNumberFields($event)">
        </div>
        <div class="col-md-2"
          [hidden]="this.titleOfQmsGroupDetailSetting=='AU' && (this.typeValue=='Findings-Critical'||this.typeValue=='Findings-Major'||this.typeValue=='Findings-Minor')">
          <div>
            <label for="email">Recalculate Closure Date When Activity Starts?</label>
          </div>
          <mat-slide-toggle color="primary" name="initiatedOnBehalfBy"
            [(ngModel)]="qmsGroupDetailTypeSettingsFieldData.recalculateClosureDateWhenActivityStarts">
            <ng-container *ngIf="qmsGroupDetailTypeSettingsFieldData.recalculateClosureDateWhenActivityStarts; else no">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #no>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row fileds-row-container1">
        <div class="col-md-4" *ngIf="visibleEditButton">
          <div><label for="email">Reason for Update</label><span class="mandatory-symbol">*</span></div>
          <textarea id="updateReason3" type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="qmsGroupDetailTypeSettingsFieldData.updateReason" (focusout)="onFieldFocusout()"></textarea>
          <span id="updateReason-required-msg3">Please provide the reason for update</span>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton"
      (click)="addAndEditFunctionForQmsGroupDetailTypeSettings(qmsGroupDetailTypeSettingsFieldData)"
      *ngIf="!visibleEditButton">
      <i class="fas fa-plus"></i> Add
    </button>
    <button mat-stroked-button class="addButton"
      (click)="addAndEditFunctionForQmsGroupDetailTypeSettings(qmsGroupDetailTypeSettingsFieldData)"
      *ngIf="visibleEditButton">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunctionForQmsGroupDetailTypeSettings()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #qmsGroupDetailTypeSettingsDeletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelQmsGroupDetailTypeSettingsDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{popupTitle}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Reason for Delete</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea3" type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="qmsGroupDetailTypeSettingsFieldData.deleteReason"
            (focusout)="onQmsGroupDetailTypeSettingsFocusout()"></textarea>
          <span id="deleteTextarea-required-msg3">Please provide the reason for delete</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton"
        (click)="deleteQmsGroupDetailTypeSettingsFunction(qmsGroupDetailTypeSettingsFieldData)">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelQmsGroupDetailTypeSettingsDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #searchUsersPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchUsersPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Search User(s) </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 10px 20px;">
    <div class="row">
      <div class="col-md-4">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" placeholder="Enter User Name"
          [(ngModel)]="searchByUserName">
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter First Name"
          [(ngModel)]="searchByFirstName">
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Last Name" [(ngModel)]="searchByLastName">
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div><label for="email">Email</label></div>
        <input class="search-filed-continers" type="text" placeholder="Enter Email" [(ngModel)]="searchByEmail">
        <div id="email-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
          (closed)="designationsearchTxt=''" (click)="focusmethod('designationfocusSearch')"
          (keydown.enter)="focusmethod('designationfocusSearch')">
          <input type="search" id="designationfocusSearch" class="dropdownsearchstyle"
            [(ngModel)]="designationsearchTxt" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDesignationSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of designationListDropdown| assessmentSearch :designationsearchTxt"
            (onSelectionChange)="onDesignationSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode" (closed)="departmentsearchTxt=''"
          (click)="focusmethod('departmentfocusSearch')" (keydown.enter)="focusmethod('departmentfocusSearch')">
          <input type="search" id="departmentfocusSearch" class="dropdownsearchstyle" [(ngModel)]="departmentsearchTxt"
            matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null"
            (onSelectionChange)="onDepartmentSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentListDropdown| assessmentSearch :departmentsearchTxt"
            (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row" style="margin-top: 4%;">
      <div class="search-button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="searchButton" (click)="searchUsersFunc()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchUsers()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="dynamic-table-container" aria-describedby="table-description" style="height: 50vh;">
        <thead>
          <th style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i class="fa-solid fa-ellipsis-vertical parent-menu-icons"></i>
              </div>
              <div style="margin-left: 5px;">
                <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="searchUserParentCheckBox"
                  (change)="onParentCheckBoxChanged($event)">
              </div>
            </div>
          </th>
          <th>
            <span>User Name</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>First Name</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Last Name</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Designation</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Department</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>EmailAddress</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th>
            <span>Is Ad User</span>
            <span class="fa-solid fa-filter multi-filter-container"></span>
          </th>
          <th id="menuu" class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let user of qmsUsersList; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="user.searchUserChildCheckBox ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input id="" type="checkbox" style="zoom: 1.2;" [checked]="user.searchUserChildCheckBox"
                    (change)="onChildCheckBoxChanged($event, user, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ user.userName }}</td>
            <td class="row-data">{{ user.firstName }}</td>
            <td class="row-data">{{ user.lastName }}</td>
            <td class="row-data">{{ user.designation }}</td>
            <td class="row-data">{{ user.department }}</td>
            <td class="row-data">{{ user.emailAddress }}</td>
            <td class="row-data" style="text-align: center; zoom: 1.2;">
              <img *ngIf="user.isAdUser" src="../../assets/img/accessSymbol.svg" alt="Yes" width="20" height="20">
              <img *ngIf="!user.isAdUser" src="../../assets/img/noAcessSymbol.svg" alt="No" width="20" height="20">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions *ngIf="showUserSearchGrid">
    <button mat-stroked-button class="addButton" (click)="getUsers()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchUsersPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #flexifieldsPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelFlexifieldsPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Flexifields</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="row">
      <div class="col-md-12">
        <app-flexible-fields-setup></app-flexible-fields-setup>
      </div>
    </div>
  </div>
</ng-template>
<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>
